import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  Checkbox,
  WhiteSpace,
  Button,
  Toast,
  Accordion,
  InputItem,
} from "antd-mobile";
import { connect } from "dva";
import { createForm } from "rc-form";
import "./adminPermission.scss";

const CheckboxItem = Checkbox.CheckboxItem;

@connect(({ admin }) => ({ admin }))
export class AssignFuncGroup extends Component {
  state = {
    funcsList: [],
    checkFuncGidArr: [],
    funcGroupIds: [],
    months: 0,
    fgids: [],
  };
  componentDidMount() {
    this.props.getFuncList();
    this.getAssignFuncGroup();
  }

  getAssignFuncGroup() {
    this.props.dispatch({
      type: 'admin/getAssignFuncGroup',
      payload: {
        adminId: this.props.match.params.id,
      },
    }).then(res => {
      const { data } = res
      if (data) {
        const { months, fgids } = data
        const d = fgids.map(item => item.id);
        this.setState({
          months: months,
          checkFuncGidArr: d || [],
          funcGroupIds: d || [],
        })
        this.props.form.setFieldsValue({
          fgids: d,
        });
      }
    });
  };

  onChange = (e, id, item) => {
    console.log(e.target.checked, id);
    let arr = this.state.checkFuncGidArr;
    console.log('this.state.funcGidArr', this.state.checkFuncGidArr)
    if (e.target.checked) {
      arr.push(item.id);
    } else {
      arr.splice(arr.map(item => item).indexOf(id), 1);
    }
    this.setState({
      checkPermissions: arr,
      funcGroupIds: [...arr]
    });
    this.props.form.setFieldsValue({
      fgids: arr,
    });
  };

  submit = () => {
    this.props.form.validateFields({ force: true }, error => {
      const fildsValue = this.props.form.getFieldsValue();
      console.log(error);
      this.props.dispatch({
        type: "admin/setAdminFuncGrp",
        payload: {
          targetId: this.props.match.params.id,
          ...fildsValue,
        }
      }).then(res => {
        if (res && res.status == 200) {
          Toast.success(res.message);
          setTimeout(() => window.history.go(-1), 1500);
        } else {
          Toast.fail(res.message);
        }
      });
    });
  }

  render() {
    const { months, funcGroupIds } = this.state;
    const { funcGroupList, } = this.props;
    const { getFieldProps, } = this.props.form;

    return (
      <div className="main-permission-list">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          分配功能组
        </NavBar>
        <div className="permission-list">
          <form>
            <List renderHeader={() => '优惠月数'}>
              <InputItem
                type="number"
                {...getFieldProps("months", {
                  initialValue: months,
                })}
                clear
                maxLength="10"
                min={0}
              >
                优惠月数
              </InputItem>
            </List>
            <List renderHeader="功能组">
              <Accordion>
                <Accordion.Panel
                  header={'功能组'}
                  {...getFieldProps("fgids", {
                  })}
                >
                  <List className="my-list">
                    {funcGroupList.map(item => {
                      return (<CheckboxItem
                        checked={funcGroupIds.includes(item.id)}
                        key={item.id}
                        onChange={e =>
                          this.onChange(
                            e,
                            item.id,
                            item,
                          )
                        }
                      >
                        {item.name}
                        <List.Item.Brief>
                          {item.remarks}
                        </List.Item.Brief>
                      </CheckboxItem>);
                    })}
                  </List>
                </Accordion.Panel>
              </Accordion>
            </List>
            <WhiteSpace size="xl" />
            <Button type="primary" onClick={() => this.submit()}>
              确定
            </Button>
            <WhiteSpace size="xl" />
            <Button onClick={() => this.props.history.goBack()}>
              返回
            </Button>
          </form>
        </div>
      </div>
    )
  }
}

const AssignFuncGroupForm = createForm()(AssignFuncGroup);
const mapStateToProps = state => {
  return {
    funcGroupList: state.app.funcGroupList,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getFuncList: () => {
      dispatch({
        type: "app/getFuncGroupList",
        payload: {},
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignFuncGroupForm);
